import * as core from '../../../../../../../core'

import { query } from './overview-donut-updated-org-structure.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.overview.widgets.donut',
    description: 'Donut chart showing Expense by Organization',
    name: 'RP Overview - Donut Expense',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
